export const useIsDark = () => {
  // const [{ theme }] = useGlobals();
  return false; // theme === THEME_DARK;
};

export const useIsLight = () => {
  // const [{ theme }] = useGlobals();
  return true; // theme === THEME_LIGHT;
};
